module.exports = __webpack_public_path__ + "img/tutorial-01.8d3b30c7.svg";